import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

import { NavigationItem } from 'components/logic/InnerLayout/components/ui/NavigationItem';
import { TrialMinerLink } from 'components/logic/InnerLayout/components/ui/TrialMinerLink/TrialMinerLink';
import { AppRoute } from 'utils/route/app-route';

import { navItems } from './constants/nav-items';

import * as S from './Navigation.styled';

interface INavigationProps {
  handlePurchaseLinkClick: () => void;
}

export const Navigation: React.FC<INavigationProps> = ({ handlePurchaseLinkClick }) => {
  const { pathname } = useLocation();
  const { t } = useTranslation();

  return (
    <S.NavWrapper as="nav">
      <S.NavList as="ul">
        {navItems.map(({ linkTo, text, iconLight, iconDark }) => (
          <NavigationItem
            key={linkTo}
            linkTo={linkTo}
            icon={pathname !== linkTo ? iconLight : iconDark}
            text={t(`menu.${text}`)}
            isCurrent={pathname === linkTo}
            onClick={linkTo === AppRoute.Purchase() ? handlePurchaseLinkClick : undefined}
          />
        ))}
        <TrialMinerLink t={t} />
      </S.NavList>
    </S.NavWrapper>
  );
};
